import Home from './home.js';
import VisitUs from './visit-us.js';
import OurWines from './our-wines.js';
import AllWines from './all-wines.js';
import WineClub from './wine-club.js';
import WinePDP from './wine-pdp.js';
import WineLocator from './wine-locator.js';
import Default from './default.js';
import SingleEvent from './single-event.js';
import DefaultPost from './default-post.js';
import Blog from './blog.js';

const Views = {
	home: Home,
	visitUs: VisitUs,
	ourWines: OurWines,
	allWines: AllWines,
	wineClub: WineClub,
	winePdp: WinePDP,
	wineLocator: WineLocator,
	default: Default,
	singleEvent: SingleEvent,
	defaultPost: DefaultPost,
	blog: Blog,
}

export default Views;
